import { connect } from 'react-redux';

import { IState } from '../../store';
import { FloatingLabel } from '../../components/FloatingLabel';
import { compose } from 'ramda';
import { withEmptyRendering } from '../../utils/hoc';
import { INewbuildingLabel, IOnlineDealSettings, TLabelType } from '../../types';
import { getNewbuildingId } from '../../selectors';

export interface INewbuildingLabelStoreProps {
  labelText: string;
  tooltipTitle: string;
  tooltipText: string;
}

export function mapStateToProps(state: IState): INewbuildingLabelStoreProps {
  const { newbuildingLabel } = state;

  let labels = {
    labelText: '',
    tooltipTitle: '',
    tooltipText: '',
  };

  if (!newbuildingLabel) {
    return labels;
  }

  const isEnabled = newbuildingLabel.isEnabled;
  if (!isEnabled) {
    return labels;
  }

  const isFromDeveloper = state.offerData.offer.newbuilding?.isFromDeveloper || false;
  const isFromLeadFactory = state.offerData.offer.newbuilding?.isFromLeadFactory || false;
  const newbuildingId = getNewbuildingId(state);

  if (newbuildingId) {
    const type = getLabelType(newbuildingId, newbuildingLabel.onlineDeal, isFromDeveloper, isFromLeadFactory);

    if (type) {
      labels = getTexts(newbuildingLabel, type);
    }
  }

  return labels;
}

export function getLabelType(
  newbuildingId: number,
  onlineDealSettings: IOnlineDealSettings[],
  isFromDeveloper: boolean,
  isFromLeadFactory: boolean,
): TLabelType | null {
  let type: TLabelType | null = null;

  if (isFromDeveloper) {
    type = 'builderOnline';
  }

  if (isFromLeadFactory) {
    type = 'consultantOnline';
  }

  onlineDealSettings.forEach(regionSettings => {
    if (regionSettings.newBuildingIds.includes(newbuildingId) && isFromDeveloper) {
      type = 'onlineDeal';
    }
  });

  return type;
}

export function getTexts(newbuildingLabel: INewbuildingLabel, type: TLabelType) {
  return {
    labelText: newbuildingLabel.indicatorTexts[type],
    tooltipTitle: newbuildingLabel.infoTexts[type].title,
    tooltipText: newbuildingLabel.infoTexts[type].text,
  };
}

export const shouldHideLabel = (props: INewbuildingLabelStoreProps) => {
  return !props.labelText;
};

export const NewbuildingLabelContainer = compose(
  connect(mapStateToProps),
  withEmptyRendering(shouldHideLabel),
)(FloatingLabel);
